module.exports = __webpack_public_path__ + "static/media/Bookmark.ac8e1da8.svg";